<div class="averia-filter">
  <ng-content></ng-content>
  @if (resetControl === 'on') {
    <app-filter-reset></app-filter-reset>
  }

  @if (refreshControl === 'auto') {
    <app-filter-refresh
    mode="auto"></app-filter-refresh>
  }
  @if (refreshControl === 'on') {
    <app-filter-refresh
    mode="manual"></app-filter-refresh>
  }
</div>
